"use strict";

exports.__esModule = true;
exports.createSdkProxy = createSdkProxy;
var _utils = require("./utils");
function noop() {
  return createSdkProxy();
}
function stringifyOnDemand(value) {
  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value);
  }
  return value;
}
function createSdkProxy(slotContentSdk = {}) {
  const pluginType = slotContentSdk == null ? void 0 : slotContentSdk.type;
  switch (pluginType) {
    case '$w.CustomElementComponent':
      return new Proxy(slotContentSdk, {
        set: (sdk, propName, value) => {
          if (typeof value !== 'function') {
            sdk.setAttribute((0, _utils.camelToKebab)(propName), stringifyOnDemand(value));
            sdk.setDirectProp(propName, value);
          } else {
            sdk.setDirectMethod(propName, value);
          }
          sdk[propName] = value;
          return true;
        },
        get: (sdk, propName) => {
          /*
            During promisification logic that checks `thenable` under the hood,
            we need to return `undefined` for `then` property to avoid unexpected behavior.
          */
          if (propName === 'then') {
            return undefined;
          }
          if (propName in sdk) {
            return sdk[propName];
          }
          if (propName === 'isMethodSupported') {
            return () => true;
          }
          return cb => {
            if (typeof cb === 'function') {
              console.warn(`Passing callbacks to plugin methods will be deprecated soon. Instead assign method directly, like: slot.${propName}(...args);`);
              sdk.setDirectMethod(propName, cb);
            }
          };
        }
      });
    default:
      return new Proxy(slotContentSdk, {
        set: (sdk, propName, value) => {
          if (propName in sdk) {
            sdk[propName] = value;
          }
          return true;
        },
        get: (sdk, propName) => {
          /*
            During promisification logic that checks `thenable` under the hood,
            we need to return `undefined` for `then` property to avoid unexpected behavior.
          */
          if (propName === 'then') {
            return undefined;
          }
          if (propName === 'isMethodSupported') {
            return methodName => methodName in sdk;
          }
          if (propName in sdk) {
            return sdk[propName];
          }
          return noop;
        }
      });
  }
}
//# sourceMappingURL=createSdkProxy.js.map